import React, { useState, useEffect } from "react"
import {
  Container,
  StepperContainer,
  StepperHeader,
  StepperHeaderElement,
  Button,
  Row,
  Col,
  Alert
} from 'design-react-kit';

import * as Constants from "../utils/constants"
import SibaCalcolaInputForm from "../components/calcolapaga/SibaCalcolaInputForm";
import SibaPrenotaPagamento from "../components/common/pagamento/SibaPrenotaPagamento";
import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import ErrorBoundary from "../components/common/ErrorBoundary";
import SibaVerificaOperazione from "../components/calcolapaga/SibaVerificaOperazione";

import { authenticate } from '../services/endpoints'
import { isUndefined, isPresentAuthenticatedUser } from "../utils/utilities";

export const SibaCalcolaPagaMain = ({ authMode }) => {

  // User data
  const [codiceFiscale, setCodiceFiscale] = useState(sessionStorage.getItem(Constants.USER_IN_SESSION));
  const [targa, setTarga] = useState('');
  const [datiPagamento, setDatiPagamento] = useState('');
  const [scenarioAlternativo, setScenarioAlternativo] = useState('');
  const [email, setEmail] = useState('');

  // Navigation
  const [currentStep, setCurrentStep] = useState(Constants.STEP_1);
  const [errorBoundaryKey, setErrorBoundaryKey] = useState(0);

  useEffect(() => {
    const loadCurrentUser = async () => {
      let user = await authenticate();
      console.log('App.js user=', user)
      if (user !== undefined) {
        if (!isUndefined(user.user)) {
          console.log('App.js user id=', user.user)
          sessionStorage.setItem(Constants.USER_IN_SESSION, user.user)
        };
      }
    }

    if (!isPresentAuthenticatedUser() && (authMode === Constants.AUTH_MODE_PROTECTED)) {
      loadCurrentUser();
    }
  }, [])

  const handleBack = () => {
    if (currentStep > Constants.STEP_1) {
      setCurrentStep(currentStep - 1);
      setErrorBoundaryKey(0)
    }
  }

  const handleNext = () => { setCurrentStep(currentStep + 1) }
  const handleChangeCodiceFiscale = (_codiceFiscale) => { setCodiceFiscale(_codiceFiscale.toUpperCase()); setDatiPagamento('') } // se lo stato è PIENO e la targa o il cf cambiano (sono tornato indietro), devo RESETTARE
  const handleTargaChange = (_targa) => { setTarga(_targa.toUpperCase()); setDatiPagamento('') } // TODO: se lo stato è PIENO e la targa o il cf cambiano (sono tornato indietro), devo RESETTARE TUTTI GLI ALTRI DATI!
  const handleEmailChange = (_email) => { setEmail(_email.toLowerCase()) }
  const handleVerificaOperazione = (_data) => {
    console.log(_data);
    if (_data.datiPagamento) {
      setDatiPagamento(_data.datiPagamento);
    }
    if (_data.scenarioAlternativo) {
      setScenarioAlternativo(_data.scenarioAlternativo);
    }
  }

  const showStep1 = () => {
    console.log("MM " + codiceFiscale)
    return (
      <ErrorBoundary FallbackComponent={OurFallbackComponentTODO} key={errorBoundaryKey}>
        <SibaCalcolaInputForm
          _cf={codiceFiscale}
          _targa={targa}
          _authMode={authMode}
          _handleCfChange={handleChangeCodiceFiscale}
          _handleTargaChange={handleTargaChange}
          _handleNext={handleNext}
        />
      </ErrorBoundary>
    );
  }

  const showStep2 = () => {
    return (
      <ErrorBoundary FallbackComponent={OurFallbackComponentTODO} key={errorBoundaryKey}>
        <SibaVerificaOperazione
          _cf={codiceFiscale}
          _targa={targa}
          _handleDataLoaded={handleVerificaOperazione}
          _handleBack={handleBack}
          _handleNext={handleNext}
        />
      </ErrorBoundary>
    );
  }

  const showStep3 = () => {
    return (
      <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
        <SibaPrenotaPagamento
          _tipoVeicolo={scenarioAlternativo}
          _targa={targa}
          _codiceFiscale={codiceFiscale}
          _calcolo={datiPagamento}
          _email={email}
          _handleEmailChange={handleEmailChange}
          _authMode={authMode}
        />
      </ErrorBoundary>
    )
  }

  const showAlarmForStep = (step) => {
    console.log('unknown step', currentStep)
    return (
      <Container className="px-2 my-2" id="calcolaPaga" tag="section">
        <Alert color="danger">Unknown step # {step}!</Alert>
      </Container>
    )
  }

  const getStepContent = (currentStep) => {
    console.log("Current step= #" + currentStep)
    switch (currentStep) {
      case Constants.STEP_1: return showStep1();
      case Constants.STEP_2: return showStep2();
      case Constants.STEP_3: return showStep3();
      default: return showAlarmForStep(currentStep);
    }
  }

  const OurFallbackComponentTODO = ({ error, componentStack, resetErrorBoundary }) => {
    return (
      <Container className="px-2 my-2" id="esitoPagamento" tag="section">
        <Alert color="danger">Errore in Calcola e Paga! {error.message}</Alert>
      </Container>
    );
  };

  const getVariantForStep = (thisStep) => {
    if (thisStep < currentStep) return Constants.STR_STEPPER_VARIANT_CONFIRMED;
    if (thisStep > currentStep) return Constants.STR_STEPPER_VARIANT_INACTIVE;
    if (thisStep === currentStep) return Constants.STR_STEPPER_VARIANT_ACTIVE;
  }

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="stepper-header" tag="section">
      <SibaBreadcrumb pageName={Constants.STR_CALCOLAPAGA_TITOLO} />
      <StepperContainer tag="div">
        <StepperHeader tag="ul">
          <>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_1}</>}
              variant={getVariantForStep(Constants.STEP_1)}
              noLine>
              <>{Constants.STR_CALCOLAPAGA_INPUT}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_2}</>}
              variant={getVariantForStep(Constants.STEP_2)}
              noLine>
              <>{Constants.STR_CALCOLAPAGA_VERIFICA}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_3}</>}
              variant={getVariantForStep(Constants.STEP_3)}
              noLine>
              <>{Constants.STR_CALCOLAPAGA_PAGAMENTO}</>
            </StepperHeaderElement>
          </>
        </StepperHeader>
      </StepperContainer>

      <Container className="px-2 my-2" id="stepper-content" tag="section">
        <ErrorBoundary>
          {getStepContent(currentStep)}
        </ErrorBoundary>
      </Container>

      <Container className="px-2 my-2" id="stepper-nav" tag="div">
        <Row>
          <Col>
            <div className="btn-toolbar justify-content-between" role="toolbar">
              <div className="btn-group mr-2">
                <Button
                  className="btn btn-outline-primary"
                  icon={false}
                  size="sm"
                  tag='a'
                  href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                  role='button'
                > {Constants.STR_BUTTON_RESET}
                </Button>
                {currentStep !== Constants.STEP_1 ? (
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag="button"
                    onClick={handleBack}
                  > {Constants.STR_BUTTON_INDIETRO}
                  </Button>
                ) : React.Fragment}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default SibaCalcolaPagaMain;